'use strict';function _extendableBuiltin(cls){function ExtendableBuiltin(){var instance=Reflect.construct(cls,Array.from(arguments));Object.setPrototypeOf(instance,Object.getPrototypeOf(this));return instance}ExtendableBuiltin.prototype=Object.create(cls.prototype,{constructor:{value:cls,enumerable:!1,writable:!0,configurable:!0}});if(Object.setPrototypeOf){Object.setPrototypeOf(ExtendableBuiltin,cls)}else{ExtendableBuiltin.__proto__=cls}return ExtendableBuiltin}

const _=require('pulsar-utils/dist-es6/_');
const Entity=require('pulsar-utils/dist-es6/domain/entity');let

InvalidNameError=class InvalidNameError extends _extendableBuiltin(Error){
constructor(message){
super();
this.message=message;
}};


const MinNameLength=1;
const MaxNameLength=50;

const MinFatigueThreshold=5;
const MaxFatigueThreshold=21;

const MinDeviationThreshold=1;
const MaxDeviationThreshold=3;

const FakeWholeOrgGroupId='00000000000000000000000000000000';let

Group=class Group extends Entity{
static get MinNameLength(){
return MinNameLength;
}

static get MaxNameLength(){
return MaxNameLength;
}

static get MinFatigueThreshold(){
return MinFatigueThreshold;
}

static get MaxFatigueThreshold(){
return MaxFatigueThreshold;
}

static get MinDeviationThreshold(){
return MinDeviationThreshold;
}

static get MaxDeviationThreshold(){
return MaxDeviationThreshold;
}

static get FakeWholeOrgGroupId(){
return FakeWholeOrgGroupId;
}

constructor(name,personIds,fatigueThreshold,deviationThreshold,creationTime,underConstruction,id){
super(id);
this.setName(name);
this._personIds=_.uniqBy(personIds,personId=>personId.toString());
this.fatigueThreshold=fatigueThreshold;
this.deviationThreshold=deviationThreshold;

_.ensureInstanceOf([Date,'nullable'],creationTime);
_.ensureInstanceOf('boolean',underConstruction);
this._creationTime=creationTime;
this._underConstruction=underConstruction;
}

setName(name){
if(name.length<MinNameLength||name.length>MaxNameLength){
throw new InvalidNameError;
}
this._name=name;
}

get name(){
return this._name;
}

get personIds(){
return this._personIds.slice();
}

get fatigueThreshold(){
return this._fatigueThreshold;
}

set fatigueThreshold(fatigueThreshold){
this._fatigueThreshold=Group.tryGetValidFatigueThreshold(fatigueThreshold);
}

get deviationThreshold(){
return this._deviationThreshold;
}

set deviationThreshold(deviationThreshold){
this._deviationThreshold=Group.tryGetValidDeviationThreshold(deviationThreshold);
}

get creationTime(){
return this._creationTime;
}

set creationTime(val){
throw new Error('can only be set from constructor');
}

get underConstruction(){
return this._underConstruction;
}

set underConstruction(val){
if(val!==!1){
throw new Error('underConstruction can only be unset');
}
this._underConstruction=!1;
}


static tryGetValidFatigueThreshold(fatigueThreshold){
_.ensureInstanceOf(['number','nullable'],fatigueThreshold);
if(!_.exists(fatigueThreshold)){
return null;
}

if(fatigueThreshold<MinFatigueThreshold||fatigueThreshold>MaxFatigueThreshold){
throw new Error(`'fatigueThreshold' out of acceptable range (${fatigueThreshold} is not between ${MinFatigueThreshold} and ${MaxFatigueThreshold})`);
}

if(!Number.isInteger(fatigueThreshold)){
throw new Error(`'fatigueThreshold' is not an integer`);
}

return fatigueThreshold;
}

static tryGetValidDeviationThreshold(deviationThreshold){
_.ensureInstanceOf(['number','nullable'],deviationThreshold);
if(!_.exists(deviationThreshold)){
return null;
}

if(deviationThreshold<MinDeviationThreshold||deviationThreshold>MaxDeviationThreshold){
throw new Error(`'deviationThreshold' out of acceptable range (${deviationThreshold} is not between ${MinDeviationThreshold} and ${MaxDeviationThreshold})`);
}

if(!Number.isInteger(deviationThreshold)){
throw new Error(`'deviationThreshold' is not an integer`);
}

return deviationThreshold;
}

static getFakeOrgGroup(defaultThresholds){
return new Group(
'Organization',
[],
defaultThresholds.fatigueThreshold,
defaultThresholds.deviationThreshold,
new Date(),!1,

FakeWholeOrgGroupId);
}

addPersonIds(personIds){
_.pushMany(this._personIds,personIds);
this._personIds=_.uniqBy(this._personIds,personId=>personId.toString());
}

removePersonIds(personIdsToRemove){
_.remove(this._personIds,personId=>_(personIdsToRemove).some(toRemove=>toRemove.equals(personId)));
}};


module.exports=Group;
module.exports.InvalidNameError=InvalidNameError;
//# sourceMappingURL=group.js.map
